export const formData = {
    message: '',
    buildingTypes: ['Multi Family', 'Single Home', 'Commercial'],
    numberOfUnits: ['1 - 99', '100 - 199', '200 or More...'],
    numberOfFloors: ['1', '2', '3 or more...'],
    numberOfSitePhasing: ['1', '2', '3', '4 or more...'],
    numberOfIDFs: ['1', '2', '3', '4 or more...'],
    isLoading: false,
    modal: false,
    deadlineDate: '',
    options: [
        {
            text: 'Option 1',
            value: '1'
        },
        {
            text: 'Option 2',
            value: '2'
        },
        {
            text: 'Option 3',
            value: '3'
        }
    ]
};
